import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';
import { CountryISO } from 'app/ngx-intl-tel-input/enums/country-iso.enum';
import { pairwise } from 'rxjs/operators';

@Component({
  selector: 'love-it-tel-input',
  templateUrl: './tel-input.component.html',
  styleUrls: ['./tel-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TelInputComponent,
      multi: true,
    },
  ],
  standalone: false,
})
export class TelInputComponent implements OnInit, ControlValueAccessor {
  @Input() placeholder: string = '+43 664 1234567';
  innerFormControl: UntypedFormControl = new UntypedFormControl();
  changeFunction: any;

  preferredCountries: string[] = [CountryISO.Austria, CountryISO.Slovenia, CountryISO.Italy];

  constructor() {}

  ngOnInit(): void {
    this.innerFormControl.valueChanges.pipe(pairwise()).subscribe(([oldValue, newValue]) => {
      if (oldValue?.internationalNumber !== newValue?.internationalNumber) {
        this.changeFunction(newValue?.internationalNumber ?? null);
      }
    });
  }

  registerOnChange(fn: any): void {
    this.changeFunction = fn;
  }

  registerOnTouched(fn: any): void {}

  writeValue(value: string | null): void {
    this.innerFormControl.patchValue(value, { emitEvent: false });
  }

  setDisabledState(isDisabled: boolean) {
    if (isDisabled) {
      this.innerFormControl.disable({ emitEvent: false });
    } else {
      this.innerFormControl.enable({ emitEvent: false });
    }
  }

  @HostListener('focusout', ['$event'])
  onFocusout(event) {
    this.innerFormControl.patchValue(this.innerFormControl.value?.internationalNumber, { emitEvent: false });
  }
}
